import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  statusList: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap('60px', '8px'),
    marginTop: '12px',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
  },
  progressBar: {
    marginTop: '16px',
  },
});
